import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("link", {
  href: "https://cdn.jsdelivr.net/npm/bootstrap/dist/css/bootstrap.min.css",
  rel: "stylesheet"
}, null, -1)
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = {
  key: 0,
  class: "public-page pt-4"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-lg-7 pt-xl-3 left-container" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "details-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_main_view = _resolveComponent("header-main-view")!
  const _component_header_download_app = _resolveComponent("header-download-app")!
  const _component_tag_view = _resolveComponent("tag-view")!
  const _component_photo_carousel = _resolveComponent("photo-carousel")!
  const _component_no_photo_video = _resolveComponent("no-photo-video")!
  const _component_description_view = _resolveComponent("description-view")!
  const _component_file_list_view = _resolveComponent("file-list-view")!
  const _component_case_creater_view = _resolveComponent("case-creater-view")!
  const _component_open_application_panel = _resolveComponent("open-application-panel")!
  const _component_drive_media_view = _resolveComponent("drive-media-view")!
  const _component_app_media_view = _resolveComponent("app-media-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_header_main_view),
      _createVNode(_component_header_download_app),
      (_ctx.driveStore.currentCase.title)
        ? (_openBlock(), _createElementBlock("main", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h1", {
                    class: "title p-0 mb-4",
                    innerHTML: _ctx.descriptionWithLink(_ctx.driveStore.currentCase.title)
                  }, null, 8, _hoisted_7),
                  _createVNode(_component_tag_view),
                  (_ctx.driveStore.currentCase.photos.length > 0)
                    ? (_openBlock(), _createBlock(_component_photo_carousel, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_no_photo_video, { key: 1 })),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_description_view),
                    _createVNode(_component_file_list_view)
                  ]),
                  _createVNode(_component_case_creater_view)
                ]),
                _createVNode(_component_open_application_panel)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.driveStore.appPhotoViewMedia && _ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_drive_media_view, {
            key: 1,
            onOnClose: _ctx.closeFullScreen
          }, null, 8, ["onOnClose"]))
        : _createCommentVNode("", true),
      (_ctx.driveStore.appPhotoViewMedia && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_app_media_view, {
            key: 2,
            onOnClose: _ctx.closeFullScreen
          }, null, 8, ["onOnClose"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}